import Vuex from 'vuex';
import Vue from 'vue';
import { SIGN_UP_NAMESPACE } from './modules/sign-up/sign-up.constants.js';
import { signUp } from './modules/sign-up/sign-up.store.js';
import { TRANSACTIONS_NAMESPACE, transactions } from './modules/transactions/transactions.store.js';

var _a;
Vue.use(Vuex);
var store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: (_a = {},
        _a[SIGN_UP_NAMESPACE] = signUp,
        _a[TRANSACTIONS_NAMESPACE] = transactions,
        _a),
});

export { store };
